import { Translation } from '@ps/web-shared-components';
import { isPast } from 'date-fns';
import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { interval } from 'rxjs';

import TimeUnits from '@swf/components/TimeUnits/TimeUnits';
import { convertMilliseconds } from '@swf/core/utils';

import { TXTWCL_XtitleXExpires_inXX_titleXXsub_ELL } from './Countdown.messages.json';
import styles from './Countdown.scss';

const formatTime = (ms: number) => {
  const time = convertMilliseconds(ms);

  return {
    days: time.days,
    hours: time.hours || '',
    minutes: time.minutes < 10 ? '0' + time.minutes : time.minutes.toString(),
    seconds: time.seconds < 10 ? '0' + time.seconds : time.seconds.toString()
  };
};

const CountDown: React.FC<{ endTime: number }> = ({ endTime }) => {
  const [startTime, setStartTime] = useState<number>(Date.now());
  const dateDiff = isPast(endTime) ? 0 : endTime - startTime;
  const { days, hours, minutes, seconds } = formatTime(dateDiff);

  useEffect(() => {
    const base = interval(1000).subscribe(() => setStartTime(Date.now()));
    if (Date.now() >= endTime) {
      base.unsubscribe();
    }
    return () => base.unsubscribe();
  }, [endTime]);

  return (
    <div className={styles.container}>
      <Translation
        {...TXTWCL_XtitleXExpires_inXX_titleXXsub_ELL}
        values={{
          0: days ? (
            <TimeUnits days={days} />
          ) : (
            <span suppressHydrationWarning>
              {hours ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`}
            </span>
          ),
          title: (text: ReactNode) => <span>{text}</span>,
          subtitle: (text: ReactNode) => <>{text}</>
        }}
      />
    </div>
  );
};

export default CountDown;
